<style type="text/css">
  :host ::ng-deep .p-button {
    font-size: 30px;
  }
</style>
<div class="wraper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div class="loaded-content" [class.blurred]="loading">
    <ngfFormData [files]="files"
                 postName="file"
                 [(FormData)]="uploadFormData"></ngfFormData>

    <!-- angular-file uploader  https://www.npmjs.com/package/angular-file-->
    <h1>Upload pTau Result File</h1>
    <p>Upload a file containing pTau results to enqueue them for processing</p>
    <hr />
    <p-button ngfSelect
              multiple="0"
              type="file"
              [(files)]="files"
              [accept]="acceptTypes"
              (filesChange)="uploadFilesChanged()"
              icon="far fa-file-csv"
              label="Browse"
              style="width:200px; height: 75px; margin-left: 300px">
    </p-button>
    &nbsp;
    <div style="margin-top: 30px; padding-top: 150px; padding-left: 200px; width: 800px; height: 300px; border: dashed 2px darkgray; background-color: white" ngfDrop selectable="1" multiple="0"
         [(files)]="files" (filesChange)="uploadFilesChanged()">
      <h2 style="margin: auto">
        Drop file here to upload
      </h2>

    </div>
  </div>
  <div id="divUploadResults" *ngIf="uploadResults != null">
    <hr />
    <h2>{{fileName}} <i *ngIf="uploadResults.numErrors == 0" style="color:darkgreen" class="ml-2 fas fa-check"></i><i *ngIf="uploadResults.numErrors != 0" style="color:red" class="ml-2 fas fa-times"></i></h2>
    <div>{{uploadResults.numSamples}} samples processed</div>
    <div>{{uploadResults.numErrors}} errors encountered</div>
    <hr />
    <div *ngFor="let sample of uploadResults.samples">
      <div *ngIf="sample.success" style="color: darkgreen">{{sample.accession}} - {{sample.interpretation}}</div>
      <div *ngIf="!sample.success" style="color: red">{{sample.accession}} - {{sample.message}}</div>
    </div>
  </div>

</div>
<p-toast>
</p-toast>
